module.exports = __webpack_public_path__ + "img/Macedonia.9f50cfff.svg";